import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import List from "@mui/icons-material/List";
import AttachMoney from "@mui/icons-material/AttachMoney";
import Schedule from "@mui/icons-material/Schedule";
import PlanListTable from "./PlanListTable";
import PlanPricingListTable from "./PlanPricingListTable";
import BillingCycleListTable from "./BillingCycleListTable";
import FeatureListTable from "./FeatureListTable";
import AdminPageShell from "../common/AdminPageShell";

type TabValue = "plans" | "plan-pricing" | "billing-cycles" | "features";

const MembershipManagementView: React.FC = () => {
  const [tab, setTab] = useState<TabValue>("plans");

  return (
    <AdminPageShell
      title="Membership management"
      description="Manage plans, plan pricing, billing cycles, and features."
    >
      <Box
        sx={{
          mb: 2,
          borderBottom: 1,
          borderColor: "divider",
          overflowX: "auto",
        }}
      >
        <Tabs
          value={tab}
          onChange={(_, v: TabValue) => setTab(v)}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            minHeight: 44,
            "& .MuiTab-root": {
              minHeight: 44,
              px: { xs: 1.5, sm: 2 },
            },
          }}
        >
          <Tab
            value="plans"
            label="Plans"
            icon={<List />}
            iconPosition="start"
          />
          <Tab
            value="plan-pricing"
            label="Pricing"
            icon={<AttachMoney />}
            iconPosition="start"
          />
          <Tab
            value="billing-cycles"
            label="Billing cycles"
            icon={<Schedule />}
            iconPosition="start"
          />
          <Tab
            value="features"
            label="Features"
            icon={<List />}
            iconPosition="start"
          />
        </Tabs>
      </Box>

      {tab === "plans" && <PlanListTable />}
      {tab === "plan-pricing" && <PlanPricingListTable />}
      {tab === "billing-cycles" && <BillingCycleListTable />}
      {tab === "features" && <FeatureListTable />}
    </AdminPageShell>
  );
};

export default MembershipManagementView;
